







































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { getRoleOptions } from "@/request/roleList";
import { downloadFile, timeFormat, jsIntString } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import { Bool } from "@/pbjs/external/ticket/ticket_pb";
import { ExecType } from "@/enum/tel.ts";
import { CallTypeEnumEnum, UDDimensionEnum } from "@/enum";
import { listUrgeDetailStatsExcelRequest } from "@/request/listUrgeDetailStats";
@Component({
  name: "RememberStatistics",
})
export default class RememberStatistics extends Vue {
  @Provide() private txt: any = this.$t;
  @Provide() private audioSrc: any = ""; // 音频src属性
  @Provide() private audioSrcNext: any = ""; // 录音文件src属性
  @Provide() private searchForm: any = {
    Itemid: null,
    Usergroupid: null,
    Username: null,
    Calltype: null,
    Phoneobject: null,
    Isreloan: null,
    Ticketstatus: null,
    Communicationway: null,
    DimensionList: [0],
    Timerange: null,
  }; // lee 搜索表单
  @Provide() private ticketStatusOptions: any = []; // 工单状态
  @Provide() private ticketTypeOptions: any = []; //  工单类型
  @Provide() private resRadioList: any = []; //联系渠道 联系方式里边
  @Provide() private PhoneObjectRelationList: any = []; //拨打对象
  @Provide() private PhoneList: any = Reflect.ownKeys(CallTypeEnumEnum)
    .slice(1)
    .map((item: any, index: number) => {
      let obj: {
        name: any;
        value: number | null;
      } = { name: "", value: null };
      switch (index) {
        // case 0:
        //   obj.label = "performance.pleaseChoose";
        //   break;
        case 0:
          obj.name = "FirstCall";
          break;
        case 1:
          obj.name = "Totalcall";
          break;
      }
      obj.value = index + 1;
      return obj;
    }); //拨打
  @Provide() private searchMethods: any = Reflect.ownKeys(UDDimensionEnum)
    .slice(0)
    .filter((item: any) => {
      if (item !== "UD_ITEM") {
        return item;
      }
    })
    .map((item: any, index: any) => {
      let obj: {
        name: string;
        value: number | null;
      } = { name: "", value: null };
      switch (index) {
        case 0:
          obj.name = "performance.date";
          obj.value = index;
          break;
        case 1:
          obj.name = "ticket.contactWay";
          obj.value = 2;
          break;
      }
      return obj;
    }); //  查询维度列表
  @Provide() private ticketstatusList: any = []; //  工单状态
  @Provide() private ticketitemList: any = []; //  工单类型
  @Provide() private communicationwaymapList: any = []; //  沟通方式
  @Provide() private phoneobjectList: any = []; //  拨打对象
  @Provide() private searchMethod: any = null; //  查询维度
  @Provide() private reloanOptions: any = [
    { name: "v0707.FirstLoan", value: Bool.BOOL_NO },
    { name: "v0707.Reloan", value: Bool.BOOL_YES },
  ];
  @Provide() private rules: any = {
    Itemid: [
      {
        required: true,
        message: "pls choose Itemid",
        trigger: "change",
      },
    ],
    Calltype: [
      {
        required: true,
        message: "pls choose Calltype",
        trigger: "change",
      },
    ],
    Timerange: [
      {
        type: "date",
        required: true,
        message: "pls choose time at least",
        trigger: "change",
      },
    ],
  };
  @Provide() private labelPosition: string = "right";
  @Provide() private resultData: any = []; // lee table列表
  @Provide() private resultDataNoCommunication: any = []; // lee table列表
  @Provide() private resultTicketItemData: any = []; // lee TicketItem列表
  @Provide() private resultRoleIDsData: any = []; // lee RoleIDs列表
  @Provide() private resultSupplierData: any = []; // lee Supplie列表
  @Provide() private chartList: any = []; // lee Supplie列表
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private pagnition: any = pagnition; // lee 分页参数
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数
  @Provide() private isSearchFormType: boolean = false; // lee 搜索按钮的loading开关
  @Provide() private isSearchFormActionDone: boolean = false; // lee 搜索按钮的loading开关
  @Provide() private isexportFormActionDone: boolean = false; // lee 搜索按钮的loading开关
  @Provide() private isDashboardActionDone: boolean = false; // lee 搜索按钮的loading开关
  @Provide() private execType: number = ExecType.EXEC_TYPE_URGE_INTERNAL; //角色
  // @Provide() private videoLoading: boolean = false; // 录音文件loading 展示
  // @Provide() private videoShow: boolean = false; // audio 展示
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getRoleListAPI(); // 获取列表数据
    this.getExtenListParam(); // 获取列表数据
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }
  private formReg(flag: any, fuc: any) {
    let _form: any = this.$refs["searchForm"];
    _form.validate((valid: any, obj: any) => {
      if (valid) {
        if (this.testSearchForm()) {
          flag = true;
          this.pageIndex = 1;
          fuc();
        }
        return true;
      } else {
        return false;
      }
    });
  }
  // 搜索操作
  private searchFormAction() {
    this.formReg(this.isSearchFormActionDone, this.getExtenList);
  }
  //  lee 导出操作
  private exportFormAction() {
    this.formReg(this.isexportFormActionDone, this.getFormList);
  }
  private async getFormList() {
    let _arg: any = this.dwSearchAction();
    const {
      setListUrgeDetailStatsReq,
      listUrgeDetailStatsExcelRequest,
    }: any = await import("@/request/listUrgeDetailStats");
    let response = await listUrgeDetailStatsExcelRequest.handleHttp(
      setListUrgeDetailStatsReq(_arg),
      this
    );
    this.isexportFormActionDone = false;
    if (response) {
      if (response.filechunk) {
        let bStr = atob(response.filechunk),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        const blob = new Blob([unit8Array], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        downloadFile(blob, response.filename);
      }
    }
  }
  // lee 搜索操作的判断
  private testSearchForm(): any {
    //  日期为必选
    if (this.searchForm.Timerange) {
      return true;
    } else {
      this.$message.error("pls choose time at least!");
      return false;
    }
  }
  // lgy 号码脱敏，保留后四位，前面按位数打星号
  private numberEncryption(number: string) {
    let len: number = number.length - 4;
    let numStrPre: string = number.substring(len, len + 4);
    let newNum: string = "";
    for (let i = 0; i < len; i++) {
      newNum += "*";
    }
    return newNum + numStrPre;
  }
  // lee 获取列表
  private async getExtenList() {
    this.isSearchFormType = this.searchForm.DimensionList.includes(2)
      ? true
      : false;
    let _arg: any = this.dwSearchAction();
    const {
      setListUrgeDetailStatsReq,
      listUrgeDetailStatsRequest,
    }: any = await import("@/request/listUrgeDetailStats");
    let res = await listUrgeDetailStatsRequest.handleHttp(
      setListUrgeDetailStatsReq(_arg),
      this
    );
    this.isSearchFormActionDone = false;
    if (res) {
      // _this.RangeType = 0;
      this.pagerCount = res.total ? res.total : res.pageout.total;
      this.resultData = res.listList;
      this.resultDataNoCommunication = res.listList.map((item: any) => {
        item.communicationwayText = this.communicationwaymapList.find(
          (itm: any) => itm[0] == item.communicationway
        )[1];
        return item;
      });
    }
  }

  //  lee 获取角色列表
  private async getRoleListAPI() {
    let _arg: any = {
      execType: this.execType,
    };
    const {
      setListUserGroupByTypeReq,
      getListUserGroupByTypeRequest,
    }: any = await import("@/request/staffManagement");
    let res = await getListUserGroupByTypeRequest.handleHttp(
      setListUserGroupByTypeReq(_arg),
      null
    );

    if (res && res.right) {
      if (res.usergroupinfosList && res.usergroupinfosList.length > 0) {
        this.resultRoleIDsData = res.usergroupinfosList;
      } else {
        this.resultRoleIDsData = [];
      }
    } else {
      this.$message.error(res.commonout.errmsg);
    }
  }
  // lee 获取查询参数
  private async getExtenListParam() {
    const {
      setListUrgeDetailStatsParamReq,
      listUrgeDetailStatsParamRequest,
    }: any = await import("@/request/listUrgeDetailStats");
    let res = await listUrgeDetailStatsParamRequest.handleHttp(
      setListUrgeDetailStatsParamReq(),
      this
    );
    if (res) {
      this.ticketstatusList =
        res && res.ticketstatusList ? res.ticketstatusList : []; //  工单状态
      this.ticketitemList = res && res.ticketitemList ? res.ticketitemList : []; //  工单类型
      this.communicationwaymapList =
        res && res.communicationwaymapMap ? res.communicationwaymapMap : []; //  沟通方式
      this.phoneobjectList =
        res && res.phoneobjectMap ? res.phoneobjectMap : []; //  拨打对象
    }
  }
  //  lee 抽离查询公共处理部分
  private dwSearchAction(): any {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      Itemid: +this.searchForm.Itemid, //是否拨通
      Usergroupid: +this.searchForm.Usergroupid, // 拨打ID
      Username: this.searchForm.Username, // Sid
      Calltype: +this.searchForm.Calltype, // 订单ID
      Phoneobject: this.searchForm.Phoneobject
        ? this.searchForm.Phoneobject.join()
        : null, // 分配员工姓名
      Isreloan: this.searchForm.Isreloan
        ? Number(this.searchForm.Isreloan)
        : null, // 工单分类
      Ticketstatus: this.searchForm.Ticketstatus, // 分机号
      Communicationway: +this.searchForm.Communicationway, // 主叫号码
      DimensionList: this.searchForm.DimensionList,
      Timerange: this.searchForm.Timerange
        ? timeFormat(this.searchForm.Timerange[0]) +
          " - " +
          timeFormat(this.searchForm.Timerange[1])
        : null, // 时间戳
    };
    return _arg;
  }
  // lee 获取录音文件
  private async getFileInfo(row: any) {
    let _arg: any = this.dwSearchAction();
    _arg.Date = row.date.split("-").join("");
    const { setHourlyUrgeStatsReq, hourlyUrgeStatsRequest }: any = await import(
      "@/request/listUrgeDetailStats"
    );
    let res = await hourlyUrgeStatsRequest.handleHttp(
      setHourlyUrgeStatsReq(_arg),
      this
    );
    this.isDashboardActionDone = false;
    if (res) {
      // this.chartList = res.chartList;
      this.goDashboard(res.chartList, row);
    }
  }
  private goDashboard(data: any, row: any) {
    let _data = JSON.stringify(data);
    let _txt = this.$tc("tableLgy.ConnectedRate");
    let routeData: any = this.$router.resolve({
      path: "RememberStatisticsDashboard",
      query: {
        list: _data,
        title: `${row.date}_${row.itemname}${_txt}`,
      },
    });
    window.open(routeData.href, "_blank");
  }
  //  lee 查询维度更改
  private async searchMethodChange() {}
}
